import { render, staticRenderFns } from "./UnitProductManagementEdit.vue?vue&type=template&id=2a1dc661&scoped=true&"
import script from "./UnitProductManagementEdit.vue?vue&type=script&lang=js&"
export * from "./UnitProductManagementEdit.vue?vue&type=script&lang=js&"
import style0 from "./UnitProductManagementEdit.vue?vue&type=style&index=0&id=2a1dc661&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1dc661",
  null
  
)

export default component.exports